<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-28 14:29:10
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/NewModelSelect.vue
-->
<template>
    <div>
        <label v-if="!hideLabel" class="block text-white text-sm mb-[10px]">
            {{ t('tools.model') }}
        </label>
        <el-select
            v-model="model"
            :style="style_class"
            class="w-full h-14 bg-item-default rounded-lg border border-transparent hover:border-white/30 min-w-[280px]"
            :popper-class="`${popper_style} model-popper`"
            :fit-input-width="true"
            :show-arrow="false"
            :placeholder="t('tools.describeModel')"
            :aria-label="t('tools.model')"
        >
            <template #label>
                <div class="flex items-center gap-2 w-full overflow-hidden">
                    <img
                        v-if="currentModel?.thumbnail"
                        :src="currentModel?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover flex-shrink-0"
                    />
                    <div class="text-sm font-medium flex flex-col gap-0.5 overflow-hidden">
                        <span
                            class="text-f-text text-white flex items-center gap-1 text-sm font-semibold truncate"
                            >{{ currentModel?.title }}</span
                        >
                        <span class="text-not-active text-xs font-medium truncate">{{
                            currentModel?.desc
                        }}</span>
                    </div>
                </div>
            </template>

            <el-option
                v-for="item in props.model_list"
                :key="item.model_key"
                :label="item.model_key"
                :value="item.model_key"
            >
                <div
                    class="flex items-center gap-2 h-full overflow-hidden whitespace-normal"
                >
                    <img
                        :src="
                            item?.model_key === model
                                ? checkedIcon
                                : notCheckedIcon
                        "
                        alt="checked"
                        class="w-5 h-5 object-cover"
                        loading="lazy"
                    />
                    <img
                        v-if="item?.thumbnail"
                        :src="item?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover"
                        loading="lazy"
                    />

                    <div class="text-sm font-medium flex flex-col gap-0.5">
                        <span
                            class="text-white flex items-center gap-1 text-sm font-semibold"
                            >{{ item?.title }}</span
                        >
                        <span
                            class="text-not-active text-xs font-medium line-clamp-1"
                            >{{ item?.desc }}</span
                        >
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useI18n } from '~/composables/useI18n'

const props = withDefaults(
    defineProps<{
        type: string
        model_list: Array<any>
        hideLabel?: boolean
        style_class?: string
        popper_style?: string
    }>(),
    {
        type: 'text_to_image',
        model_list: () => [],
        hideLabel: false,
        style_class: '',
        popper_style: '',
    }
)
const { t, locale } = useI18n()

const checkedIcon =
    'https://static.weryai.com/growth/image/4ebae3f3edb8f4f52281d018c7816648.webp'
const notCheckedIcon =
    'https://static.weryai.com/growth/image/bd6f71cdf35a64773b80d7a5a9930322.webp'

const model = defineModel('model', {
    type: String,
    default: '',
})

onMounted(() => {})

const currentModel = computed(() => {
    return props.model_list.find(item => item.model_key === model.value)
})
</script>
<style scoped lang="less">
:deep(.el-select__wrapper) {
    height: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    &:hover {
        border: none;
        box-shadow: none;
    }
    &:focus-visible {
        border: none;
    }
}
</style>

<style lang="less">
.model-popper {
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    background-color: rgba(30, 35, 45, 0.75) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;

    // 确保覆盖 Element Plus 默认背景
    &.el-popper,
    .el-select-dropdown {
        background-color: transparent !important;
    }

    .el-select-dropdown__item {
        height: 60px !important;
        margin-bottom: 10px !important;
        margin: 0 10px !important;
        border-radius: 10px !important;
        &.is-hovering {
            background-color: rgba(255, 255, 255, 0.1) !important;
        }
        &.is-selected {
            background-color: transparent !important;
        }
    }
}

/**
 * Mobile override: when parent passes popper_style="mobile_popper_style",
 * disable blur and use solid dark background.
 * (PC keeps the default glassmorphism above.)
 */
.mobile_popper_style.model-popper {
    -webkit-backdrop-filter: none !important;
    backdrop-filter: none !important;
    background-color: rgba(0, 0, 0, 0.7) !important;
}
.mobile_popper_style.model-popper.el-popper,
.mobile_popper_style.model-popper .el-select-dropdown {
    background-color: rgba(0, 0, 0, 0.7) !important;
}

/* Fallback: for browsers/webviews that don't support backdrop-filter */
@supports not ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
    .model-popper {
        /* 不支持模糊时的兜底：加深背景，保证可读性 */
        background-color: rgba(0, 0, 0, 0.7) !important;
    }
}

[type='text']:focus,
[type='email']:focus,
[type='password']:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    color: #fff !important;
}
</style>
